<template>
  <div class="relative w-12 h-full">
    <div class="absolute-center p-6 bg-white border-round-2xl">
      <slot />
    </div>
  </div>
</template>